import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mga-real-money-balance-page__header" }
const _hoisted_2 = { class: "mga-real-money-balance-page__header-action" }
const _hoisted_3 = { class: "mga-real-money-balance-page__header-action-round-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReportTimestamp = _resolveComponent("ReportTimestamp")!
  const _component_DownloadActions = _resolveComponent("DownloadActions")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_MgaRealMoneyBalancePageListFilter = _resolveComponent("MgaRealMoneyBalancePageListFilter")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_TwoFactorAuthDialog = _resolveComponent("TwoFactorAuthDialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_container, { class: "mga-real-money-balance-page" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h2", null, "Real money balance by " + _toDisplayString(_ctx.reportPeriod), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_2, [
            (_ctx.isTimestampAllowed)
              ? (_openBlock(), _createBlock(_component_ReportTimestamp, { key: 0 }))
              : _createCommentVNode("v-if", true),
            (_ctx.isReportDownloadAllowed)
              ? (_openBlock(), _createBlock(_component_DownloadActions, {
                  key: 1,
                  type: "primary",
                  "is-loading": _ctx.isRealMoneyBalancePlayerListLoading,
                  onGetReport: _ctx.openTwoFactorDialog
                }, null, 8 /* PROPS */, ["is-loading", "onGetReport"]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_popover, {
                placement: "bottom",
                "show-arrow": false,
                width: 400,
                visible: _ctx.isFilterVisible,
                "popper-class": "mga-real-money-balance-page__filter"
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    loading: _ctx.isRealMoneyBalancePlayerListLoading,
                    round: "",
                    icon: _ctx.icons.Filter,
                    onClick: _ctx.toggleFilterVisibility
                  }, {
                    default: _withCtx(() => [
                      _cache[2] || (_cache[2] = _createTextVNode(" Filters ", -1 /* CACHED */)),
                      _createVNode(_component_el_tag, {
                        effect: "dark",
                        round: "",
                        size: "small",
                        class: "mga-real-money-balance-page__filter-counter"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.activeFiltersCount), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["loading", "icon", "onClick"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_MgaRealMoneyBalancePageListFilter)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["visible"]),
              _createVNode(_component_el_button, {
                circle: "",
                icon: _ctx.icons.Refresh,
                loading: _ctx.isRealMoneyBalancePlayerListLoading,
                onClick: _ctx.getRealMoneyBalancePlayerList
              }, null, 8 /* PROPS */, ["icon", "loading", "onClick"])
            ])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      size: "small",
      class: "mga-real-money-balance-page__table",
      border: "",
      "tooltip-effect": "light",
      data: _ctx.realMoneyBalancePlayerList,
      onSortChange: _ctx.updateListSorting
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.realMoneyBalancePlayerTable, (column) => {
          return (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
            key: column.label
          }, { ref_for: true }, column), null, 16 /* FULL_PROPS */))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["data", "onSortChange"])), [
      [_directive_loading, _ctx.isRealMoneyBalancePlayerListLoading]
    ]),
    _createVNode(_component_el_pagination, {
      "current-page": _ctx.currentPage,
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
      "page-size": _ctx.itemsPerPage,
      "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.itemsPerPage) = $event)),
      class: "mga-real-money-balance-page__pagination",
      size: "small",
      "page-sizes": _ctx.PAGINATION_PROPERTIES.pageSizes,
      layout: _ctx.PAGINATION_PROPERTIES.layout,
      total: _ctx.listItemsCount,
      "data-v-test": "pagination",
      onSizeChange: _ctx.updatePaginationLimit,
      onCurrentChange: _ctx.updateCurrentPage
    }, null, 8 /* PROPS */, ["current-page", "page-size", "page-sizes", "layout", "total", "onSizeChange", "onCurrentChange"]),
    (_ctx.isTwoFactorDialogVisible)
      ? (_openBlock(), _createBlock(_component_TwoFactorAuthDialog, {
          key: 0,
          action: _ctx.getRealMoneyBalancePlayerListCsv
        }, null, 8 /* PROPS */, ["action"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}